import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAuth from './auth.reducer';
import { AuthEffects } from './auth.effects';
import { AuthStore } from './auth.store';
import { CommonBackendModule } from '../../backend/common/common-backend.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.reducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [
    AuthStore,
    ...CommonBackendModule.forRoot().providers,
  ],
})
export class AuthStoreModule { }
